import { mapState } from "vuex";
export const msgIndexMixins = {
  computed: {
    msgTopBarList() {
        let topbarList = [
          {
            name: "消息管理",
            isActive: false,
            path: "/msgManage",
            icon:require("@/assets/img/menuIcons/icon-msgManage.png")
          },
        ];
        topbarList.forEach((val) => {
          if (val.path == this.$route.path) {
            val.isActive = true;
          }
          if (val.childrenPath) {
            if (~val.childrenPath.indexOf(this.$route.path)) {
              val.isActive = true;
            }
          }
        });
        return topbarList;
      },
  },
}
